<template>
  <v-dialog v-model="visible" max-width="400">
    <v-card>
      <v-card-title class="text-h6" :style="estiloTituloVentana">
         <v-icon class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">mdi-select-marker</v-icon>
         Ajuste de plazas
      </v-card-title>

      <v-card-text class="pa-5">
        <h3 class="mb-4">{{descripcion}}</h3>

        <!-- total plazas  -->
        <v-row dense>
          <v-col cols="5" class="d-flex align-center justify-end">
             <span class="body-2">{{$t ('Plazas')}}:</span>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="totalPlazas"
              prepend-icon="mdi-minus"
              append-outer-icon="mdi-plus"
              readonly
              solo
              dense
              type="text"
              hide-details
              v-inputfilter="{ expresionRegular: ['[^0-9]', 'g'], longitudMaxima: 5 }"
              @click:prepend="totalPlazas--"
              @click:append-outer="totalPlazas++"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- plazas libres -->
        <v-row dense>
          <v-col cols="5" class="d-flex align-center justify-end">
             <span class="body-2" style="font-weight: 700">{{$t ('Plazas libres')}}:</span>
          </v-col>
          <v-col cols="5">
            <v-text-field
              ref="plazasLibres"
              v-model="plazasLibres"
              prepend-icon="mdi-minus"
              append-outer-icon="mdi-plus"
              solo
              dense
              type="text"
              hide-details
              v-inputfilter="{ expresionRegular: ['[^0-9]', 'g'], longitudMaxima: 5 }"
              @focus="$event.target.select()"
              @click:prepend="plazasLibres--"
              @click:append-outer="plazasLibres++"
              @keypress.enter="botonAceptarClick"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- plazas ocupadas -->
        <v-row dense>
          <v-col cols="5" class="d-flex align-center justify-end">
             <span class="body-2">{{$t ('Plazas ocupadas')}}:</span>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="plazasOcupadas"
              prepend-icon="mdi-minus"
              append-outer-icon="mdi-plus"
              solo
              dense
              type="text"
              hide-details
              v-inputfilter="{ expresionRegular: ['[^0-9]', 'g'], longitudMaxima: 5 }"
              @focus="$event.target.select()"
              @click:prepend="plazasOcupadas--"
              @click:append-outer="plazasOcupadas++"
              @keypress.enter="botonAceptarClick"
            ></v-text-field>
          </v-col>
        </v-row>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="!env.VUE_APP_FORMULARIOS_SOLO_LECTURA">
          <v-btn text color="green darken-2" @click="botonAceptarClick">
            {{ $t ('Aceptar') }}
          </v-btn>
        </template>
        <v-btn text @click="botonCancelarClick">
          {{ $t ('Cerrar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    this.promesaResolve = null;
    this.promesaReject = null;
    this.botonAceptarClicado = false;
    return {
      estiloTituloVentana: '',
      visible: false,
      descripcion: '',
      totalPlazas: null,
      plazasLibres: null,
      plazasOcupadas: null,
    }
  },
  computed: {
    env () {
      return process.env;
    }
  },
  watch: {
    visible () {
      if (!this.visible) { // al cerrarse la ventana, finalizamos la promesa. Si se ha pulsado el boton imprimir, la resolvemos; si no, la rechazamos
        if (this.botonAceptarClicado)
          this.promesaResolve({
            total_plazas: parseInt (this.totalPlazas),
            plazas_libres: parseInt (this.plazasLibres),
            plazas_ocupadas: parseInt (this.plazasOcupadas),
          });
        else
          this.promesaReject();
      }
    },
    totalPlazas () {
      this.plazasLibres = this.totalPlazas - this.plazasOcupadas;
    },
    plazasLibres () {
      this.plazasOcupadas = this.totalPlazas - this.plazasLibres;
    },
    plazasOcupadas () {
      this.plazasLibres = this.totalPlazas - this.plazasOcupadas;
    }
  },
  methods: {
    abrirVentana (zona, colorTitulo = '#90D0F0') {
      this.estiloTituloVentana = 'background: '+colorTitulo;

      this.descripcion = zona.descripcion;
      this.totalPlazas = zona.total_plazas;
      this.plazasLibres = zona.plazas_libres;
      this.plazasOcupadas = zona.plazas_ocupadas;

      this.botonAceptarClicado = false;
      let resultado = new Promise ((resolve, reject) => {
        this.promesaResolve = resolve;
        this.promesaReject = reject;
      });

      this.visible = true;

      setTimeout(() => {
        this.$refs['plazasLibres'].focus();
      }, 350);

      return resultado;
    },
    botonAceptarClick () {
      this.botonAceptarClicado = true;
      this.visible = false;
    },
    botonCancelarClick () {
      this.visible = false;
    }
  }
}
</script>

<style scoped>

</style>